import { useEffect } from 'react';

type DataLayerEvent = {
  event: string;
  page?: string;
  label?: string;
  category?: string;
  [key: string]: any;
};

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

const GTMClickListener = () => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;

      // find the nearest parent object that has a 'data-gtm-event' attribute (whos
      //    value will be the 'event' value of the object that gets pushed onto
      //    the GTM dataLayer event list)
      const el = target.closest('[data-gtm-event]') as HTMLElement | null;
      if (!el) return;

      // eg, expect any data-gtm-* event on the 'el' to be converted into
      //    a key and value in the event that gets pushed to the dataLayer
      const event_payload = Object.keys(el.dataset).reduce((acc, key) => {
          if (key.startsWith('gtm')) {
              const formattedKey = key
              .replace(/^gtm/, '')
              .replace(/^[A-Z]/, (m) => m.toLowerCase());

              acc[formattedKey] = el.dataset[key];
          }
          return acc;
      }, {});

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: el.dataset.gtmEvent || 'unknown_event',
        page: window.location.pathname,
        ...event_payload,
      });
    };

    document.addEventListener('click', handler);

    return () => document.removeEventListener('click', handler);
  }, []);

  return null;
};

export default GTMClickListener;
